import React from 'react'
import { dataWisata } from '../../constants';

function Wisata() {
  return (
    <section id='wisata' className="background-black">
      <div className="container text-center color-secondary">
        <div className='mb-5'>
          <h2 className='mb-3'>Destinasi Wisata di Kota Palu</h2>
          <p className='desc'>Rekomendasi destinasi wisata di kota Palu & sekitarnya yang dapat anda kunjungi</p>
        </div>
        <div className='d-flex flex-wrap justify-content-center align-items-center' style={{rowGap: '20px', columnGap: "20px"}}>
          {
            dataWisata.map(wisata => {
              return(
                <div 
                  className='d-flex flex-column justify-content-center wisata'
                  key={wisata.id}
                  data-aos="zoom-in" 
                  data-aos-duration="800" 
                >
                  <img src={wisata.src} alt={wisata.name} className="image-wisata" />
                  <h6 className='mt-3 desc'>{wisata.name}</h6>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default Wisata